import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function VisualSystemSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section className="pt-10 pb-0 px-4 bg-[#E8F6FB]" data-id="element-204">
      <div ref={ref} className={`max-w-2xl mx-auto ${isVisible ? 'reveal-visible' : 'reveal-hidden'}`} data-id="element-205">
        {/* Title */}
        <h2 className="text-3xl md:text-4xl font-extrabold text-[#1a1a1a] text-center mb-8 leading-tight tracking-tight" data-id="element-206">
          Un{' '}
          <span className="italic underline underline-offset-4 decoration-[3px]" data-id="element-207">
            sistema visual
          </span>
          <br data-id="element-208" />
          que tus hijos sí quieren seguir...
        </h2>

        {/* Collage image */}
        <div className="w-full" data-id="element-209">
          <img src="https://cdn.magicpatterns.com/uploads/o5BTfcHPEYbBMDAi5253ad/Este_MegaKit_de_Lectura_es_para_ti_si....png" alt="Sistema visual de lectura - materiales del MegaKit" className="w-full h-auto" data-id="element-210" />
        </div>
      </div>
    </section>;
}